import { Account, AccountSummary, OrganiseMember } from '@karehero/models';

type ProfilePictureSource =
  | Pick<Account, 'avatarUrl' | 'kindeUser'>
  | Pick<AccountSummary, 'avatarUrl'>
  | OrganiseMember
  | {
      avatarUrl?: string | null;
      kindeUser?: {
        picture?: string | null;
      } | null;
    };

/**
 * Returns the best available profile picture URL for an account.
 *
 * Priority:
 * 1. Custom avatar URL (account.avatarUrl)
 * 2. Kinde SSO profile picture (excluding blank defaults)
 * 3. undefined (caller should show initials fallback)
 */
export function getProfilePictureUrl(
  account: ProfilePictureSource | null | undefined,
): string | undefined {
  if (!account) return undefined;

  // Custom avatar takes priority (avatarUrl added by avatar-editor feature)
  if ('avatarUrl' in account && account.avatarUrl)
    return account.avatarUrl as string;

  // Kinde SSO picture, excluding blank/default placeholders
  if ('kindeUser' in account) {
    const kindePicture = account.kindeUser?.picture;
    if (kindePicture && !kindePicture.includes('d=blank')) {
      return kindePicture;
    }
  }

  return undefined;
}
